import { useEffect, useState } from 'react';

/** Returns the value only after it has stopped changing for `delayMs`. */
export function useDebouncedValue(value: string, delayMs = 400): string {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return debounced;
}
